import React from "react";
import Layout from "../../components/Layout";
import * as S from "./styles";
import { imageApi, getContainDimensions } from "../../helpers";
import ImageWPlaceholder from "../../components/ImageWPlaceholder";
import IframeWPlaceholder from "../../components/IframeWPlaceholder";
import { Link } from "react-router-dom";

const Arrow = function () {
  return (
    <svg
      width="32px"
      height="29px"
      viewBox="0 0 32 29"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <path d="M30.79785,14.5 L1.608435,14.5" />
      <polyline points="17 1 31 14.5 17 28" />
    </svg>
  );
};

class Work extends React.Component {
  state = {
    width: "auto",
  };
  componentDidMount() {
    window.addEventListener("resize", this.onResize);
    this.onResize();
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.onResize);
  }

  onResize = () => {
    const containerRect = this._container.getBoundingClientRect();
    const aspect = this.props.src.width / this.props.src.height;
    const maxHeight = Math.min(1600, Math.max(500, window.innerHeight * 0.8));
    const dimens = getContainDimensions(aspect, containerRect.width, maxHeight);
    const width = dimens.width + "px";
    this.setState({
      width,
    });
  };

  render() {
    const { src, title, year, embed } = this.props;
    const isPortrait = src && src.height > src.width;
    const image = imageApi(src, { fixWidth: 1600 });
    const wrapperStyle = {
      width: this.state.width,
    };
    return (
      <S.Work
        portrait={isPortrait}
        ref={(c) => {
          this._container = c;
        }}
      >
        <S.ImageSizer style={wrapperStyle}>
          {embed ? (
            <IframeWPlaceholder {...embed} key={src.src} />
          ) : (
            <ImageWPlaceholder {...image} key={src.src} />
          )}
          <S.WorkInfo>
            <div>
              {title}
              {!!year && `, ${year}`}
            </div>
            {/* {!!medium && <div>{medium}</div>}
        {!!dimensions && <div>{dimensions}</div>} */}
          </S.WorkInfo>
        </S.ImageSizer>
      </S.Work>
    );
  }
}

const Works = ({ title, years, images, slug, works }) => {
  const index = works.findIndex((o) => o.uri === `works/${slug}`);
  const prev = index - 1;
  const next = index + 1;
  return (
    <Layout>
      <S.TitleContainer>
        <S.Title>
          {title}
          {!!years && `, ${years}`}
        </S.Title>
        <S.PrevNext>
          <S.Prev
            to={`/${works[prev] && works[prev].uri}`}
            $isHidden={prev < 0}
          >
            <Arrow />
          </S.Prev>
          <S.Next
            to={`/${works[next] && works[next].uri}`}
            $isHidden={next >= works.length}
          >
            <Arrow />
          </S.Next>
        </S.PrevNext>
      </S.TitleContainer>
      <S.WorksList>
        {images.map((o) => (
          <Work {...o} key={o.src.src} />
        ))}
      </S.WorksList>
    </Layout>
  );
};

export default Works;
